import React from 'react';

/**
 * Quick stats summary card.
 * @param {{ icon: React.ReactNode, label: string, value: string, hint?: string }} props
 */
function StatCard({ icon, label, value, hint }) {
  return (
    <div className="exam-dashboard__stat">
      <div className="exam-dashboard__stat-icon">{icon}</div>
      <p className="exam-dashboard__stat-label">{label}</p>
      <p className="exam-dashboard__stat-value">{value}</p>
      {hint ? <p className="exam-dashboard__stat-hint">{hint}</p> : null}
    </div>
  );
}

export default StatCard;
